export default "__VITE_ASSET__Pvej0OgR__"